<template>
  <SmartConfigProvider :global-config="globalConfig">
    <RouterView />
  </SmartConfigProvider>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { RouterView } from 'vue-router'
import { SmartConfigProvider } from '@/components/base'
import { useThemeStore } from '@/stores/theme'

const theme = useThemeStore()

const globalConfig = computed(() => ({
  classPrefix: 't',
  size: theme.state.componentSize === 'large' ? 'large' : theme.state.componentSize === 'small' ? 'small' : 'medium'
}))
</script>
